import { render, staticRenderFns } from "./BasicContextMenu.vue?vue&type=template&id=1e204821&scoped=true&"
import script from "./BasicContextMenu.vue?vue&type=script&lang=js&"
export * from "./BasicContextMenu.vue?vue&type=script&lang=js&"
import style0 from "./BasicContextMenu.vue?vue&type=style&index=0&id=1e204821&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e204821",
  null
  
)

export default component.exports